import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71781f42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "element-loading-background": "rgba(0, 0, 0, 0.5)" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 编辑出库货量 ", -1))
const _hoisted_3 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-6px","margin-right":"-10px"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c"} }, "*", -1))
const _hoisted_5 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"46px"}
}
const _hoisted_6 = ["title"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c"} }, "*", -1))
const _hoisted_8 = ["title"]
const _hoisted_9 = ["title"]
const _hoisted_10 = ["title"]
const _hoisted_11 = ["title"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c"} }, "*", -1))
const _hoisted_13 = ["title"]
const _hoisted_14 = ["title"]
const _hoisted_15 = {
  key: 0,
  style: {"color":"red","font-weight":"600"}
}
const _hoisted_16 = ["title"]
const _hoisted_17 = ["title"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 0,
  style: {"font-size":"13px","color":"#fe995b","font-weight":"900","padding-top":"15px"}
}
const _hoisted_20 = { style: {"clear":"both","margin-top":"30px"} }
const _hoisted_21 = { style: {"float":"left"} }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 0,
  style: {"float":"left","width":"100%","font-size":"14px","color":"red"}
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding":"0px","text-align":"center","margin":"0px","padding-left":"20px","padding-right":"20px"} }, " KGS ", -1))
const _hoisted_25 = {
  key: 0,
  style: {"float":"left","width":"100%","font-size":"14px","color":"red"}
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding":"0px","text-align":"center","margin":"0px","padding-left":"20px","padding-right":"20px"} }, " m³ ", -1))
const _hoisted_27 = {
  key: 0,
  style: {"float":"left","width":"100%","font-size":"14px","color":"red"}
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left"} }, "入库货量", -1))
const _hoisted_29 = {
  key: 0,
  style: {"float":"left","width":"70%","margin-top":"10px","margin-left":"20px"}
}
const _hoisted_30 = { style: {"float":"left","margin-right":"20px"} }
const _hoisted_31 = { style: {"float":"left","margin-right":"10px"} }
const _hoisted_32 = { style: {"float":"left","margin-right":"10px"} }
const _hoisted_33 = { style: {"float":"right"} }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = ["title"]
const _hoisted_36 = ["title"]
const _hoisted_37 = ["title"]
const _hoisted_38 = ["title"]
const _hoisted_39 = {
  key: 1,
  style: {"clear":"both","margin-top":"30px"}
}
const _hoisted_40 = { style: {"clear":"both","height":"25px","padding-top":"3px","margin-top":"20px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_ArrowDownBold = _resolveComponent("ArrowDownBold")!
  const _component_ArrowUpBold = _resolveComponent("ArrowUpBold")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_miezz_button_bar = _resolveComponent("miezz-button-bar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.ruleForm.Visible,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.ruleForm.Visible) = $event)),
      top: "0px",
      "show-close": false,
      style: {"width":"96%"},
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": true
    }, {
      header: _withCtx(({ close }) => [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_icon, {
            style: {"cursor":"pointer"},
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CloseBold)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "ruleFormInStock",
          model: _ctx.outStocks,
          "label-width": "150px",
          rules: _ctx.customsPackageTableRules
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_table, {
                ref: "customsPackageTable",
                data: _ctx.outStocks.Data.Items,
                onSelectionChange: _ctx.handleSelectionChange
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    type: "index",
                    label: "序号",
                    width: "60"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "Shape",
                    label: "箱规cm×cm×cm"
                  }, {
                    header: _withCtx(() => [
                      _hoisted_4,
                      _createTextVNode(" 箱规cm×cm×cm ")
                    ]),
                    default: _withCtx((scope) => [
                      (_ctx.isDetail!=true)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createVNode(_component_el_form_item, {
                              "label-width": "0px",
                              label: "",
                              prop: 'Data.Items.' + scope.$index + '.Shape',
                              rules: [
                                                          {
                                                            required: true,
                                                            message: '信息不能为空',
                                                            trigger: 'blur',
                                                          },
                                                        ]
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: scope.row.Shape,
                                  "onUpdate:modelValue": ($event: any) => ((scope.row.Shape) = $event),
                                  filterable: "",
                                  placeholder: "请选择",
                                  onChange: ($event: any) => (_ctx.onChangeShape(scope.$index,false))
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectInStocks, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.Data.Shape,
                                        label: item.Label,
                                        value: item.Data.Shape
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
                              ]),
                              _: 2
                            }, 1032, ["prop"])
                          ]))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"},
                            title: scope.row.Shape
                          }, _toDisplayString(scope.row.Length + '×' + scope.row.Width + '×' + scope.row.Height), 9, _hoisted_6))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "GrossWeight",
                    label: "单件毛重KGS",
                    width: "180"
                  }, {
                    header: _withCtx(() => [
                      _hoisted_7,
                      _createTextVNode(" 单件毛重KGS ")
                    ]),
                    default: _withCtx((scope) => [
                      (_ctx.isDetail!=true)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            style: {"width":"100% !important","overflow":"hidden","height":"46px"},
                            title: scope.row.GrossWeight
                          }, [
                            _createVNode(_component_el_form_item, {
                              "label-width": "0px",
                              label: "",
                              prop: 'Data.Items.' + scope.$index + '.GrossWeight',
                              rules: [
                                                          {
                                                            required: true,
                                                            message: '信息不能为空',
                                                            trigger: 'blur',
                                                          },
                                                        ]
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(), _createBlock(_component_el_select, {
                                  key: _ctx.grossWeightRandom,
                                  disabled: scope.row.Shape!=null && scope.row.Shape!=undefined && scope.row.Shape!=''?false:true,
                                  onFocus: ($event: any) => (_ctx.onFocusShape(scope.$index)),
                                  modelValue: scope.row.GrossWeight,
                                  "onUpdate:modelValue": ($event: any) => ((scope.row.GrossWeight) = $event),
                                  filterable: "",
                                  placeholder: "请选择",
                                  onChange: ($event: any) => (_ctx.onChangeGrossWeight(scope.$index))
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.GrossWeights, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item,
                                        label: item,
                                        value: item
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["disabled", "onFocus", "modelValue", "onUpdate:modelValue", "onChange"]))
                              ]),
                              _: 2
                            }, 1032, ["prop"])
                          ], 8, _hoisted_8))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"},
                            title: scope.row.GrossWeight
                          }, _toDisplayString(scope.row.GrossWeight), 9, _hoisted_9))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "Volume",
                    label: "单件体积CBM",
                    width: "180"
                  }, {
                    default: _withCtx((scope) => [
                      (_ctx.isDetail!=true)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            style: {"width":"100% !important","overflow":"hidden","height":"46px"},
                            title: scope.row.Volume
                          }, [
                            _createVNode(_component_el_form_item, {
                              "label-width": "0px",
                              label: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_miezz_input, {
                                  placeholder: "请填写",
                                  disabled: true,
                                  modelValue: scope.row.Volume,
                                  "onUpdate:modelValue": ($event: any) => ((scope.row.Volume) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 2
                            }, 1024)
                          ], 8, _hoisted_10))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"},
                            title: scope.row.Volume
                          }, _toDisplayString(scope.row.Volume), 9, _hoisted_11))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "OutStockQuantity",
                    label: "出库数量"
                  }, {
                    header: _withCtx(() => [
                      _hoisted_12,
                      _createTextVNode(" 出库数量 ")
                    ]),
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_row, { gutter: 20 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 20 }, {
                            default: _withCtx(() => [
                              (_ctx.isDetail!=true)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    style: {"width":"100% !important","overflow":"hidden","height":"46px"},
                                    title: scope.row.OutStockQuantity
                                  }, [
                                    _createVNode(_component_el_form_item, {
                                      "label-width": "0px",
                                      label: "",
                                      rules: _ctx.customsPackageTableRules.OutStockQuantity,
                                      prop: 'Data.Items.' + scope.$index + '.OutStockQuantity'
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_miezz_input, {
                                          placeholder: "请填写",
                                          disabled: _ctx.outStocks.Data.IsShiftout!=true && scope.row.Shape!=null && scope.row.Shape!=undefined && scope.row.Shape!=''?false:true,
                                          modelValue: scope.row.OutStockQuantity,
                                          "onUpdate:modelValue": ($event: any) => ((scope.row.OutStockQuantity) = $event),
                                          onBlur: ($event: any) => (_ctx.onChangeOutStockQuantity(scope.$index))
                                        }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "onBlur"])
                                      ]),
                                      _: 2
                                    }, 1032, ["rules", "prop"])
                                  ], 8, _hoisted_13))
                                : (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"},
                                    title: scope.row.OutStockQuantity
                                  }, _toDisplayString(scope.row.OutStockQuantity), 9, _hoisted_14))
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_col, { span: 4 }, {
                            default: _withCtx(() => [
                              (scope.row.IsShiftout)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_15, "移库"))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "OutStockTime",
                    label: "出库日期"
                  }, {
                    header: _withCtx(() => [
                      _createTextVNode(" 出库日期 ")
                    ]),
                    default: _withCtx((scope) => [
                      (_ctx.isDetail!=true)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            style: {"width":"100% !important","overflow":"hidden","height":"46px"},
                            title: scope.row.OutStockTime
                          }, [
                            _createVNode(_component_el_form_item, {
                              "label-width": "0px",
                              label: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_date_picker, {
                                  modelValue: scope.row.OutStockTime,
                                  "onUpdate:modelValue": ($event: any) => ((scope.row.OutStockTime) = $event),
                                  type: "datetime",
                                  disabled: _ctx.outStocks.Data.IsShiftout!=true?false:true,
                                  placeholder: "请选择",
                                  format: "YYYY/MM/DD HH:mm",
                                  "default-time": _ctx.defaultTime
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "default-time"])
                              ]),
                              _: 2
                            }, 1024)
                          ], 8, _hoisted_16))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"},
                            title: scope.row.OutStockTime
                          }, _toDisplayString(scope.row.OutStockTime), 9, _hoisted_17))
                    ]),
                    _: 1
                  }),
                  (_ctx.isDetail!=true)
                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                        key: 0,
                        label: "操作",
                        width: "60"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("div", {
                            style: {"cursor":"pointer"},
                            onClick: ($event: any) => (_ctx.onDelete(scope.$index)),
                            title: "删除"
                          }, [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_Delete)
                              ]),
                              _: 1
                            })
                          ], 8, _hoisted_18)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["data", "onSelectionChange"]),
              (_ctx.isDetail!=true && _ctx.list.Data!=undefined && _ctx.list.Data.Items!=undefined && _ctx.list.Data.Items.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("span", {
                      style: {"cursor":"pointer"},
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onAdd && _ctx.onAdd(...args)))
                    }, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Plus)
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" 添加")
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_el_row, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 8 }, {
                    default: _withCtx(() => [
                      (_ctx.isDetail!=true)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            label: "合计件数",
                            prop: "Data.SumQuantityOutStock",
                            rules: [
                                                          {
                                                            required: true,
                                                            message: '信息不能为空',
                                                            trigger: 'blur',
                                                          },
                                                        ]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.outStocks.Data.SumQuantityOutStock,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.outStocks.Data.SumQuantityOutStock) = $event)),
                                disabled: (_ctx.outStocks.Data!=undefined && _ctx.outStocks.Data.Items!=undefined && _ctx.outStocks.Data.Items.length > 0)?true:false,
                                class: "input-with-select",
                                onBlur: _ctx.onChangeSumQuantity
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: _ctx.outStocks.Data.ChargeUnitOutStock,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.outStocks.Data.ChargeUnitOutStock) = $event)),
                                    style: {"width":"100% !important","background-color":"#fff"},
                                    filterable: "",
                                    "allow-create": "",
                                    "default-first-option": "",
                                    "reserve-keyword": false,
                                    placeholder: "请选择"
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.packageEnHistorys, (item, index) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.Label,
                                          label: item.Label,
                                          value: item.Label
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", _hoisted_21, _toDisplayString(item.Label), 1),
                                            (item.Data.IsHistory==true)
                                              ? (_openBlock(), _createElementBlock("span", {
                                                  key: 0,
                                                  style: {"float":"right","color":"var(--el-text-color-secondary)","font-size":"13px"},
                                                  onClick: ($event: any) => (_ctx.onDeletePackageEn(item.Value,index))
                                                }, [
                                                  _createVNode(_component_el_icon, null, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_Delete)
                                                    ]),
                                                    _: 1
                                                  })
                                                ], 8, _hoisted_22))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 2
                                        }, 1032, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["modelValue", "disabled", "onBlur"]),
                              (_ctx.outStocks.Data.SumQuantityOutStock!=null && _ctx.outStocks.Data.SumQuantityOutStock!=undefined && _ctx.outStocks.Data.SumQuantityOutStock != _ctx.outStocks.Data.SumQuantityInStock)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, " 与入库货量不一致 "))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 1,
                            label: "合计件数"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.outStocks.Data.SumQuantityOutStock) + _toDisplayString(_ctx.outStocks.Data.ChargeUnitOutStock), 1)
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 8 }, {
                    default: _withCtx(() => [
                      (_ctx.isDetail!=true)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            label: "合计毛重"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.outStocks.Data.SumGrossWeightOutStock,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.outStocks.Data.SumGrossWeightOutStock) = $event)),
                                onBlur: _ctx.onChangeSumGrossWeight,
                                disabled: (_ctx.outStocks.Data!=undefined && _ctx.outStocks.Data.Items!=undefined && _ctx.outStocks.Data.Items.length > 0)?true:false
                              }, {
                                append: _withCtx(() => [
                                  _hoisted_24
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onBlur", "disabled"]),
                              (_ctx.outStocks.Data.SumGrossWeightOutStock!=null && _ctx.outStocks.Data.SumGrossWeightOutStock!=undefined && _ctx.outStocks.Data.SumGrossWeightOutStock != _ctx.outStocks.Data.SumGrossWeightInStock)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, " 与入库货量不一致 "))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 1,
                            label: "合计毛重"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.outStocks.Data.SumGrossWeightOutStock) + "KGS ", 1)
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 8 }, {
                    default: _withCtx(() => [
                      (_ctx.isDetail!=true)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            label: "合计体积"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.outStocks.Data.SumVolumeOutStock,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.outStocks.Data.SumVolumeOutStock) = $event)),
                                onBlur: _ctx.onChangeSumVolume,
                                disabled: (_ctx.outStocks.Data!=undefined && _ctx.outStocks.Data.Items!=undefined && _ctx.outStocks.Data.Items.length > 0)?true:false
                              }, {
                                append: _withCtx(() => [
                                  _hoisted_26
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onBlur", "disabled"]),
                              (_ctx.outStocks.Data.SumVolumeOutStock!=null && _ctx.outStocks.Data.SumVolumeOutStock!=undefined && _ctx.outStocks.Data.SumVolumeOutStock != _ctx.outStocks.Data.SumVolumeInStock)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_27, " 与入库货量不一致 "))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 1,
                            label: "合计体积"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.outStocks.Data.SumVolumeOutStock) + "m³ ", 1)
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      (_ctx.isDetail!=true)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            label: "备注"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.outStocks.Data.RemarkOutStock,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.outStocks.Data.RemarkOutStock) = $event)),
                                rows: 5,
                                type: "textarea"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 1,
                            label: "备注"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.outStocks.Data.RemarkOutStock,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.outStocks.Data.RemarkOutStock) = $event)),
                                rows: 5,
                                disabled: true,
                                type: "textarea"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"]),
        _createVNode(_component_el_card, { style: {"margin-top":"20px"} }, {
          header: _withCtx(() => [
            _createElementVNode("div", {
              style: {"width":"100% !important","cursor":"pointer","height":"50px","line-height":"50px"},
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isInStock = !_ctx.isInStock))
            }, [
              _hoisted_28,
              (_ctx.isInStock==true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createVNode(_component_el_form_item, { label: "合计件数" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.list.Data.SumQuantityInStock) + _toDisplayString(_ctx.list.Data.ChargeUnitInStock), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(_component_el_form_item, { label: "合计毛重" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.list.Data.SumGrossWeightInStock) + "KGS ", 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(_component_el_form_item, { label: "合计体积" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.list.Data.SumVolumeInStock) + "m³ ", 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_33, [
                (_ctx.isInStock==false)
                  ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ArrowDownBold)
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ArrowUpBold)
                      ]),
                      _: 1
                    }))
              ])
            ])
          ]),
          default: _withCtx(() => [
            (_ctx.isInStock==false)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _createVNode(_component_el_table, { data: _ctx.inStocks }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        prop: "Leng",
                        label: "箱规cm×cm×cm"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("div", {
                            style: {"width":"100% !important","overflow":"hidden","word-break":"break-all","height":"26px","line-height":"26px"},
                            title: scope.row.Label
                          }, _toDisplayString(_ctx.isString(scope.row.Label)), 9, _hoisted_35)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "GrossWeight",
                        label: "单件毛重KGS"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("div", {
                            style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"},
                            title: scope.row.Data.GrossWeight
                          }, _toDisplayString(_ctx.isString(scope.row.Data.GrossWeight)), 9, _hoisted_36)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "Volume",
                        label: "单件体积CBM"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("div", {
                            style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"},
                            title: scope.row.Data.Volume
                          }, _toDisplayString(_ctx.isString(scope.row.Data.Volume)), 9, _hoisted_37)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "Quantity",
                        label: "入库数量"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("div", {
                            style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"},
                            title: scope.row.Data.InStockQuantity
                          }, _toDisplayString(_ctx.isString(scope.row.Data.InStockQuantity)), 9, _hoisted_38)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["data"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isInStock==false)
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _createVNode(_component_el_row, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 8 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "合计件数" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.list.Data.SumQuantityInStock) + _toDisplayString(_ctx.list.Data.ChargeUnitInStock), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 8 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "合计毛重" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.list.Data.SumGrossWeightInStock) + "KGS ", 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 8 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "合计体积" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.list.Data.SumVolumeInStock) + "m³ ", 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_40, [
          _createVNode(_component_miezz_button_bar, {
            modelValue: _ctx.bottomButtons,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.bottomButtons) = $event)),
            isBackground: true,
            onHandleClick: _ctx.handleClick
          }, null, 8, ["modelValue", "onHandleClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ])), [
    [
      _directive_loading,
      _ctx.isLoading,
      void 0,
      {
        fullscreen: true,
        lock: true
      }
    ]
  ])
}